import { Injectable } from '@angular/core';
import { PortalFieldConfig } from '@portal/form/data-access';
import { CreditReportRequestModelKeys } from '../const/form-field-key.const';

@Injectable({ providedIn: 'root' })
export class CreditReportRequestFormConfigService {
  initCreditReportRequestFormFields(): PortalFieldConfig[] {
    return [
      {
        key: CreditReportRequestModelKeys.creditReportRequest,
        type: '#yesNo',
        defaultValue: true,
        props: { required: true, disabled: true },
      },
    ];
  }
}
